import React, { memo } from "react";

import colors from "app/colors";
import { useMixpanel } from "modules/providers/mixpanel-provider";
import { MIXPANEL_EVENT_TYPE } from "modules/providers/mixpanel-provider/mixpanel-provider";
import { ChatEllipsisIcon } from "modules/icons";
import { useOverlay } from "modules/providers/overlay-provider";
import { DRAWER_TYPE } from "modules/providers/overlay-provider/overlay-provider";
import { Button } from "@chakra-ui/react";
import { CHAT_DRAFT_ID } from "modules/utils/Constants";
import useMessageThreadDraft from "modules/hooks/use-message-thread-draft";
import { MessageThreadType } from "gql/graphql";

export const LeftNavCreateThreadButton = () => {
  const { openDrawer } = useOverlay();
  const { track } = useMixpanel();
  const { createDraft } = useMessageThreadDraft({ draftId: CHAT_DRAFT_ID });

  const onNewChatClicked = React.useCallback(async () => {
    await createDraft({
      type: MessageThreadType.Chat,
      draftType: "new-thread",
    });
    openDrawer({ type: DRAWER_TYPE.COMPOSE_CHAT });
    track(MIXPANEL_EVENT_TYPE.LINK, {
      "Link Location": "Left Hand Nav",
      "Link Action": "New Chat",
    });
  }, [createDraft, openDrawer, track]);

  return (
    <Button
      aria-label="new chat"
      variant="hover"
      backgroundColor={colors.blue}
      color={colors.white}
      size="xs"
      rounded="full"
      iconSpacing={1}
      fontSize={10}
      fontWeight={700}
      onClick={onNewChatClicked}
      leftIcon={<ChatEllipsisIcon boxSize={3} fill={colors.white} />}
      px={2}
      w="78px"
    >
      New Chat
    </Button>
  );
};

export default memo(LeftNavCreateThreadButton);
